import { Eye, EyeOff } from 'lucide-react'
import type { FieldVisibilityDto } from '../types'

type Mode = 'HIDDEN' | 'READ' | 'EDIT'

export function visibilityMode(v: FieldVisibilityDto | undefined): Mode {
  if (!v || !v.canView) return 'HIDDEN'
  if (v.canEdit) return 'EDIT'
  return 'READ'
}

/**
 * Badge wyświetlany obok nazwy sekcji w tabach. EDIT (default) NIE renderuje
 * badge'a - byłby on zbędną dekoracją na każdej zakładce. Pokazujemy tylko
 * odstępstwa od defaultu: PODGLĄD / UKRYTE.
 */
export function SectionVisibilityBadge({ visibility }: { visibility: FieldVisibilityDto | undefined }) {
  const mode = visibilityMode(visibility)
  if (mode === 'EDIT') return null
  if (mode === 'READ') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 px-1.5 py-0.5 text-[10px] font-medium">
        <Eye size={10} />
        Podgląd
      </span>
    )
  }
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 text-slate-500 border border-slate-200 px-1.5 py-0.5 text-[10px] font-medium">
      <EyeOff size={10} />
      Ukryte
    </span>
  )
}
